
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * Service AuthService
 */
import { Injectable } from '@angular/core';
import { HttpParams } from "@angular/common/http";
import { HttpClientService } from './httpClient.service';



@Injectable()
export class AuditTrailService {
  private _baseURL = "/api/audittrail";
  LIMIT = 40;
  constructor(private _http: HttpClientService) {
  }

  getMine(mineOnly?, q?: string, pid?, file?, offset = 0, limit = this.LIMIT) {

    let url = this._baseURL;
    if (pid) {
      url += '/pid/' + pid;
    } else if (file) {
      url += '/file/' + file;
    } else {
      url += '/me/';
    }

    let params = new HttpParams();
    params = params.set('limit', limit.toString());
    params = params.set('offset', offset.toString());
    if (mineOnly) {
      params = params.set('mineOnly', 'true');
    }
    if (q) {
      params = params.set('q', q);
    }
    if (params.keys().length) {
      url += '?' + params.toString();
    }
    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
